// extracted by mini-css-extract-plugin
export default {"wrapper":"EditChargingStation_wrapper__ZSTsi"};